import { DropZone } from "@measured/puck";

export const configPUCK = {
  components: {
    // Heading Block with H1 to H6, text alignment, and padding options
    HeadingBlock: {
      fields: {
        // Select input for heading level
        level: {
          type: "select",
          options: [
            { label: "H1", value: 1 },
            { label: "H2", value: 2 },
            { label: "H3", value: 3 },
            { label: "H4", value: 4 },
            { label: "H5", value: 5 },
            { label: "H6", value: 6 },
          ],
        },
        // Text content for the heading
        children: {
          type: "text",
        },
        // Alignment settings (left, center, right)
        textAlign: {
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
        },
        // Padding settings (none, small, medium, large)
        padding: {
          type: "text",
        },
      },
      render: ({ level, children, textAlign, padding }) => {
        const Tag = `h${level}`; // Dynamically choose heading tag (h1 to h6)
        const style = {
          textAlign, // Apply text alignment
          padding, // Apply padding
        };
        return <Tag style={style}>{children}</Tag>;
      },
    },
    TextBlock: {
      fields: {
        // Text content for the paragraph
        text: {
          type: "textarea",
        },
        // Alignment settings (left, center, right)
        textAlign: {
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
        },
        // Padding settings (none, small, medium, large)
        padding: {
          type: "select",
          options: [
            { label: "None", value: "0" },
            { label: "Small", value: "10px" },
            { label: "Medium", value: "20px" },
            { label: "Large", value: "40px" },
          ],
        },
        fontSize: {
          type: "text",
        },
      },
      render: ({ text, textAlign, padding, fontSize }) => {
        const style = {
          textAlign, // Apply text alignment
          padding, // Apply padding
          fontSize,
          margin: "0",
        };
        return <p style={style}>{text}</p>;
      },
    },
    FlexBlock: {
      fields: {
        // Array of flex items
        items: {
          type: "array",
          arrayFields: {
            title: { type: "text" }, // Title of each flex item
            textAlign: {
              type: "select",
              options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
              ],
            },
            padding: {
              type: "select",
              options: [
                { label: "None", value: "0" },
                { label: "Small", value: "10px" },
                { label: "Medium", value: "20px" },
                { label: "Large", value: "40px" },
              ],
            },
            fontSize: {
              type: "text", // Allows users to input a font size
            },
          },
        },
        justifyContent: {
          type: "select",
          options: [
            { label: "Start", value: "flex-start" },
            { label: "Center", value: "center" },
            { label: "End", value: "flex-end" },
            { label: "Space Between", value: "space-between" },
            { label: "Space Around", value: "space-around" },
          ],
        },
        alignItems: {
          type: "select",
          options: [
            { label: "Start", value: "flex-start" },
            { label: "Center", value: "center" },
            { label: "End", value: "flex-end" },
          ],
        },
        flexDirection: {
          type: "select",
          options: [
            { label: "Row", value: "row" },
            { label: "Column", value: "column" },
          ],
        },
      },
      render: ({
        items = [
          { title: "Box 1", textAlign: "center", padding: "10px" },
          { title: "Box 2", textAlign: "center", padding: "10px" },
          { title: "Box 3", textAlign: "center", padding: "10px" },
        ],
        justifyContent,
        alignItems,
        flexDirection,
      }) => {
        const containerStyle = {
          display: "flex",
          justifyContent,
          alignItems,
          flexDirection,
          gap: "10px",
        };

        const dropZoneStyle = {
          border: "2px dotted #888", // Dotted border for visibility
          padding: "10px",
          minHeight: "100px", // Optional: set a minimum height for visibility
          flex: 1, // Ensures equal width for each flex item
        };

        return (
          <div style={containerStyle}>
            {items.map((item, i) => {
              const style = {
                textAlign: item.textAlign,
                padding: item.padding,
                fontSize: item.fontSize || "inherit", // Default to inherit if no font size is provided
                flex: 1, // Ensures equal width for each item
              };
              return (
                <div key={i} style={style}>
                  {/* DropZone with dotted border */}
                  <DropZone zone={`flex-item-${i}`} style={dropZoneStyle}>
                    {item.title}
                  </DropZone>
                </div>
              );
            })}
          </div>
        );
      },
    },
  },
};
